// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  // Tooltip,
  // InputAdornment,
  Box,
  useMediaQuery,
  Alert,
  AlertTitle,
} from '@mui/material';
import styles from './styles';
import EirLoader from '../eir-loader/EirLoader';

const EirValidateCollapseContent = ({
  radioValue,
  handleRadioChange,
  showContent,
  bbUanRef,
  handleBBuanChange,
  handleCtaClick,
  bbUanNo,
  uanError1,
  enableCta,
  showLoader,
  setUanDetails,
  serviceCheck,
  qaForBB,
  selectedUanService,
  uanDetails,
}) => {
  const theme = useTheme();
  const [currentbbProvider, setCurrentbbProvider] = React.useState();
  const [bbuanlabel, setbbuanLabel] = React.useState();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  useEffect(() => {
    if (currentbbProvider === 'VIRGIN MEDIA') {
      setbbuanLabel('Virgin Media Account Number');
    } else {
      setbbuanLabel('UAN (Universal Account Number)');
    }
    setUanDetails({ ...uanDetails, provider: currentbbProvider });
  }, [currentbbProvider]);

  return (
    <CardContent sx={styles(theme).collapseContainer}>
      <Grid container>
        <Grid item xs={12}>
          <FormControl>
            <RadioGroup
              row
              name='yes-no'
              value={radioValue}
              onChange={handleRadioChange}
              onKeyDown={event => {
                const radios = Array.from(
                  event.currentTarget.querySelectorAll('input[type="radio"]')
                );
                const active = document.activeElement;
                const index = radios.indexOf(active);

                // Arrow keys → move focus only
                if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(event.key)) {
                  event.preventDefault();

                  let next = index;
                  if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                    next = (index + 1) % radios.length;
                  } else {
                    next = (index - 1 + radios.length) % radios.length;
                  }

                  radios[next]?.focus();
                  return;
                }

                // Enter → trigger selection (with visible dot)
                if (event.key === 'Enter') {
                  event.preventDefault();
                  active?.click(); // triggers MUI selection & your onChange
                }
              }}
              sx={styles(theme).radioButton}
            >
              <FormControlLabel value='yes' control={<Radio />} label='Yes' />
              <FormControlLabel value='no' control={<Radio />} label='No' />
            </RadioGroup>
          </FormControl>
        </Grid>
        {showContent && (
          <Grid container item xs={12}>
            <Grid container item xs={12} rowSpacing={2} sx={{ mt: '1rem', mb: '24px' }}>
              <Grid item xs={12} md={4}>
                <Grid sx={styles(theme).inputContainer}>
                  <FormControl
                    variant='outlined'
                    fullWidth
                    size='medium'
                    sx={styles(theme).inputTextbox}
                  >
                    <InputLabel id='current-bb-label'>Current Broadband Provider*</InputLabel>
                    <Select
                      // sx={styles(theme).inputTextbox}
                      sx={{
                        '& .MuiSvgIcon-root': { color: theme.palette.primary.buttonColor },
                      }}
                      fullWidth
                      labelId='current-bb-label'
                      id='current-bb'
                      value={currentbbProvider}
                      label='Current Broadband Provider*'
                      onChange={e => setCurrentbbProvider(e.target.value)}
                    >
                      <MenuItem value='DIGIWEB' sx={{ color: theme.palette.primary.textColor3 }}>
                        DIGIWEB
                      </MenuItem>
                      <MenuItem value='IFA' sx={{ color: theme.palette.primary.textColor3 }}>
                        IFA
                      </MenuItem>
                      <MenuItem value='IMAGINE' sx={{ color: theme.palette.primary.textColor3 }}>
                        IMAGINE
                      </MenuItem>
                      <MenuItem value='OTHER' sx={{ color: theme.palette.primary.textColor3 }}>
                        OTHER
                      </MenuItem>
                      <MenuItem value='PURE' sx={{ color: theme.palette.primary.textColor3 }}>
                        PURE
                      </MenuItem>
                      <MenuItem value='SKY' sx={{ color: theme.palette.primary.textColor3 }}>
                        SKY
                      </MenuItem>
                      <MenuItem
                        value='VIRGIN MEDIA'
                        sx={{ color: theme.palette.primary.textColor3 }}
                      >
                        VIRGIN MEDIA
                      </MenuItem>
                      <MenuItem value='VODAFONE' sx={{ color: theme.palette.primary.textColor3 }}>
                        VODAFONE
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {showContent && currentbbProvider && (
                <Grid item xs={12} md={4}>
                  <Grid sx={styles(theme).inputContainer}>
                    <TextField
                      fullWidth
                      inputRef={bbUanRef}
                      label={bbuanlabel}
                      id='phoneno'
                      required
                      onChange={handleBBuanChange}
                      {...(bbUanNo ? { defaultValue: bbUanNo } : {})}
                      sx={styles(theme).inputTextbox}
                      InputProps={{
                        style: { color: theme.palette.primary.textColor3 },
                        maxLength: 8,
                        // endAdornment: (
                        //   <InputAdornment position='end'>
                        //     {' '}
                        //     <Tooltip
                        //       title='UAN must be 8 digits long and only contain numbers'
                        //       enterDelay={200}
                        //       leaveDelay={800}
                        //       enterTouchDelay={0}
                        //     >
                        //       <InfoOutlinedIcon sx={{ color: 'rgba(50, 52, 53, 0.54)' }} />
                        //     </Tooltip>
                        //   </InputAdornment>
                        // ),
                      }}
                    />
                    {uanError1 && currentbbProvider === 'VIRGIN MEDIA' ? (
                      <Typography variant='body2' sx={styles(theme).errorMessage}>
                        Account number must be 8 digits long and only contain numbers
                      </Typography>
                    ) : (
                      uanError1 && (
                        <Typography variant='body2' sx={styles(theme).errorMessage}>
                          UAN must be 8 digits long and only contain numbers
                        </Typography>
                      )
                    )}
                  </Grid>
                </Grid>
              )}
              {showContent && currentbbProvider && (
                <Grid item xs={12} md={4} sx={styles(theme).buttonContainer}>
                  {!showLoader && (
                    <Box sx={{ mt: '13px' }}>
                      <Button
                        onClick={handleCtaClick}
                        variant='buttonMedium'
                        sx={enableCta ? styles(theme).enableCTA : styles(theme).disableCTA}
                        aria-label='Check the details of your current broadband service'
                      >
                        Check
                      </Button>
                    </Box>
                  )}
                  <Box sx={{ mt: '1rem', display: !showLoader && 'none' }}>
                    {showLoader && (
                      <EirLoader loaderTitle='Checking' buttonSize={sm ? { width: '100%' } : ''} />
                    )}
                  </Box>
                </Grid>
              )}
            </Grid>
            {qaForBB?.serviceDetails?.length > 1 && (
              <Grid container item xs={12} rowSpacing={2} sx={{ mb: '24px' }}>
                <Grid item xs={12} md={4}>
                  <Grid sx={styles(theme).inputContainer}>
                    <FormControl
                      variant='outlined'
                      fullWidth
                      size='medium'
                      sx={styles(theme).inputTextbox}
                    >
                      <InputLabel id='current-bb-label'>Choose a service</InputLabel>
                      <Select
                        // sx={styles(theme).inputTextbox}
                        sx={{
                          '& .MuiSvgIcon-root': { color: theme.palette.primary.buttonColor },
                        }}
                        fullWidth
                        labelId='current-bb-label'
                        id='current-bb'
                        value={selectedUanService}
                        label='Choose a service*'
                        onChange={e => serviceCheck(e.target.value)}
                      >
                        {qaForBB?.serviceDetails.map(service => (
                          <MenuItem key={service.phoneNumber} value={service.phoneNumber}>
                            {service.phoneNumber}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {showContent && currentbbProvider && currentbbProvider !== 'VIRGIN MEDIA' && (
              <Grid xs={12} sm={12}>
                <Alert
                  severity='info'
                  sx={{ '& .MuiSvgIcon-root': { color: theme.palette.secondary.OfferSelected } }}
                >
                  <AlertTitle
                    sx={{
                      color: theme.palette.secondary.OfferSelected,
                      pb: '16px',
                      fontSize: '14px',
                      lineHeight: '22px',
                    }}
                  >
                    You will find the Universal Account Number (UAN) on your bill,{' '}
                    <strong>enter only the 8-digits.</strong> It can be either an 8-digit number or
                    a few letters plus 8-digits.
                  </AlertTitle>
                  <span style={{ color: theme.palette.secondary.OfferSelected }}>
                    Example: 12345678 or XXXX12345678{' '}
                  </span>
                </Alert>
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
    </CardContent>
  );
};

export default EirValidateCollapseContent;
